export const DRAGGABLE_KEY_PREFIX = 'draggable'
